/**
 * Тонкая обёртка над MAX Bridge (`window.WebApp`).
 * Скрипт подключён в index.html; вне мессенджера объекта просто нет,
 * поэтому каждый вызов сначала проверяет доступность.
 * Документация: https://dev.max.ru/docs/webapps/bridge
 */

export interface MaxContact {
  phone: string
  authDate: string
  hash: string
}

interface MaxWebApp {
  initData?: string
  initDataUnsafe?: { start_param?: string; user?: { id?: number } }
  requestContact?: () => Promise<MaxContact>
  shareMaxContent?: (params: { text?: string; link?: string }) => Promise<unknown>
  shareContent?: (params: { text?: string; link?: string }) => Promise<unknown>
}

function bridge(): MaxWebApp | null {
  const app = (window as typeof window & { WebApp?: MaxWebApp }).WebApp

  return app && typeof app === 'object' ? app : null
}

/** Приложение открыто внутри MAX и есть подписанные данные запуска. */
export function isInsideMax(): boolean {
  return Boolean(bridge()?.initData)
}

export function initData(): string {
  return bridge()?.initData ?? ''
}

export function canRequestContact(): boolean {
  return typeof bridge()?.requestContact === 'function'
}

export async function requestContact(): Promise<MaxContact | null> {
  const app = bridge()
  if (typeof app?.requestContact !== 'function') {
    return null
  }

  const contact = await app.requestContact()

  return contact?.phone ? contact : null
}

/** Делится ссылкой-приглашением через мессенджер; вне MAX возвращает false. */
export async function shareInvite(text: string, link: string): Promise<boolean> {
  const app = bridge()
  const share = app?.shareMaxContent ?? app?.shareContent
  if (typeof share !== 'function') {
    return false
  }

  try {
    await share({ text, link })
    return true
  } catch {
    return false
  }
}
